export const ROUTES = {
  AUTH: '/auth',
  CONFIRM_ALPHA: '/confirm-alpha',
  DOCUMENTATION: '/documentation',
  LICENSE_AGREEMENT: '/license-agreement',
  MAP: '/map',
  MAIN: '/',
  PROFILE: '/profile',
}
